import { useWalletSwitchDetector } from "@/hooks";

/**
 * HOC component that detects wallet switches and handles logout.
 * This ensures the wallet switch detection logic only runs once in the app.
 */
export function WalletSwitchDetector() {
    useWalletSwitchDetector();
    return null;
}
